import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getFinalPreparationSectionKey } from './getSectionData';

export const getFinalPreparationReactiveScopeData = (wir: WIR | null, countrySelect: string) => {
  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : getFinalPreparationSectionKey(countrySelect);
  const IWOP = wir?.phases?.[phase]?.sections?.iwop;

  return {
    phase,
    IWOP,
  };
};
